import _ from 'lodash';

// Rejections keep the server's `code` and `extra` so components can branch on a coded failure.
// PUT /api/Products/:id sends some failures as error: { message } rather than a string.
export const toApiError = err => {
  const failure = _.get(err, 'data.error');
  const message = (typeof failure === 'string' ? failure : _.get(failure, 'message')) || _.get(err, 'message') || 'Request failed.';
  return Object.assign(new Error(message), _.pick(_.get(err, 'data'), ['code', 'extra']));
};
